import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'hardest_part'

const OPTIONS = [
  {
    value: 'strong-cravings',
    translationKey: 'pages.onboarding.hardestPart.options.strong-cravings',
  },
  {
    value: 'guilt-or-shame',
    translationKey: 'pages.onboarding.hardestPart.options.guilt-or-shame',
  },
  {
    value: 'social-pressure',
    translationKey: 'pages.onboarding.hardestPart.options.social-pressure',
  },
  {
    value: 'anxiety-or-stress',
    translationKey: 'pages.onboarding.hardestPart.options.anxiety-or-stress',
  },
  {
    value: 'fear-of-weight-gain',
    translationKey: 'pages.onboarding.hardestPart.options.fear-of-weight-gain',
  },
]

const ANSWER_TEXTS = {
  'strong-cravings': 'Strong cravings',
  'guilt-or-shame': 'Guilt or shame',
  'social-pressure': 'Social pressure',
  'anxiety-or-stress': 'Anxiety or stress',
  'fear-of-weight-gain': 'Fear of weight gain',
}

export default function HardestPartPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your biggest challenge in quitting?",
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.hardestPart.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
